/* eslint-disable no-unused-expressions */
/**
 * Created by zad on 17/4/26.
 */
import { noop } from '@/utils/util';
import i18n from 'react-intl-universal';
import { getState as getNoteContentState } from '@/reducers/NoteContent/NoteContentReducer';
import { getState as getNotesState } from '@/reducers/Notes/NotesReducer';
import { put, call, takeLatest, select, takeEvery } from 'redux-saga/effects';
import { getState } from '../reducers/Notebooks/NotebooksReducer';
import Message from '../components/Message';
import ajax from '../utils/ajax';
import { Notes, Global } from '../constants/actionTypes';
import { NOTES_NOT_FOUND } from '../constants/variables';

function* getNotesAsync(action) {
  const { nbId, isForce, page = 1, count = 10, nid = null } = action;
  const notebooks = yield select(getState);
  const notes = notebooks.getIn(['entities', nbId, 'notes'], NOTES_NOT_FOUND);
  try {
    // 总是获取数据，因为我们现在支持分页
    const { data } = yield call(ajax.getNotes, nbId, page, count, nid);
    yield put({ type: Notes.GET_NOTES_SUCCESS, data, nbId, page, count, isForce, nid });
  } catch (e) {
    yield put({ type: Notes.GET_NOTES_FAIL });
  }
}

function* sortNotesAsync(action) {
  const { newSeq, oldSeq, nbId } = action;
  try {
    const { data } = yield call(ajax.sortNotes, newSeq);
    yield put({ type: Notes.SORT_NOTES_SUCCESS });
  } catch (e) {
    yield put({ type: Notes.SORT_NOTES_FAIL, oldSeq, nbId });
  }
}

function* newNoteAsync(action) {
  const { nbId, title, resolve, reject, atBottom, hasTop } = action;
  // 没有文集或者没有选中文集需要提示
  if (!nbId) {
    Message.error(i18n.get('error.no-nb'));
    yield put({ type: Notes.NEW_NOTE_FAIL, error: {} });
    reject({}, nbId);
    return;
  }
  try {
    const { data } = yield call(ajax.newNote, { nbId, title, atBottom, hasTop });
    yield put({ type: Notes.NEW_NOTE_SUCCESS, data, nbId, atBottom, hasTop });
    resolve(data, nbId);
  } catch (error) {
    yield put({ type: Notes.NEW_NOTE_FAIL, error });
    reject(error, nbId);
  }
}

// 这个是仅仅发布非付费文章的接口
function* publishNoteAsync(action) {
  const { forcedPublish } = action;
  let { noteId = '' } = action;
  noteId = noteId.toString();
  const noteContentState = yield select(getNoteContentState);
  const content = noteContentState.getIn(['entities', noteId, 'content'], '');
  // 提示文章内容为空
  if (!content.trim()) {
    Message.error(i18n.get('error.content-no-empty'));
    yield put({ type: Notes.PUBLISH_NOTE_FAIL, error: {}, noteId });
    return;
  }
  const notes = yield select(getNotesState);
  const { shared, title, slug, paid } = notes.getIn(['entities', noteId]).toJS();
  try {
    const { data } = yield call(ajax.publishNote, noteId, forcedPublish);
    // 首次发布需要跳转至发布成功的modal页面
    if (!shared) {
      yield put({
        type: Global.SET_PUBLISH_SUCCESS_MODAL_DATA,
        show: true,
        data: { noteId, title, slug, paid },
      });
    }
    yield put({ type: Notes.PUBLISH_NOTE_SUCCESS, data, noteId });
  } catch (error) {
    yield put({ type: Notes.PUBLISH_NOTE_FAIL, error, noteId });
    // 如果是未绑定手机，则需要提示用户绑定手机
    const resError = error.error;
    if (resError && resError[0] && resError[0].code === 7) {
      yield put({ type: Global.SET_BIND_PHONE_STATUS, hasBind: false, noteId });
    }
    if (resError && resError[0] && resError[0].code === 2030) {
      let { data } = resError[0];
      data = JSON.parse(data || '{}');
      yield put({
        type: Global.SET_BIND_STATUS,
        status: false,
        data,
      });
    }
  }
}

function* updateNoteAsync(action) {
  const { noteId, title, content, resolve = noop, reject = noop } = action;
  const notes = yield select(getNotesState);
  const autosaveControl = notes.getIn(['entities', noteId, 'autosave_control']);
  try {
    const { data } = yield call(ajax.updateNote, noteId, autosaveControl, title, content);
    yield put({ type: Notes.UPDATE_NOTE_SUCCESS, data, noteId });
    resolve(data);
  } catch (error) {
    yield put({ type: Notes.UPDATE_NOTE_FAIL, error, noteId });
    reject(error);
  }
}

function* privateNoteAsync(action) {
  const { noteId } = action;
  try {
    const { data } = yield call(ajax.privateNote, noteId);
    yield put({ type: Notes.PRIVATE_NOTE_SUCCESS, data, noteId });
  } catch (error) {
    yield put({ type: Notes.PRIVATE_NOTE_FAIL, error, noteId });
  }
}

function* deleteNoteSoftAsync(action) {
  const { noteId, nbId, doneCallback } = action;
  try {
    const { data } = yield call(ajax.deleteNoteSoft, noteId);
    yield put({ type: Notes.DEL_NOTE_SOFT_SUCCESS, data, noteId, nbId });
    doneCallback(null, data);
  } catch (resError) {
    yield put({ type: Notes.DEL_NOTE_SOFT_FAIL, resError, noteId, nbId });
    doneCallback(resError.error);
  }
}

// 移动文章
function* moveNoteAsync(action) {
  const { nbId, noteId, newNbId, doneCallback } = action;
  try {
    const { data } = yield call(ajax.moveNote, newNbId, noteId);
    yield put({ type: Notes.MOVE_NOTE_SUCCESS, data, noteId, newNbId, nbId });
    doneCallback(null, data);
  } catch (error) {
    yield put({ type: Notes.MOVE_NOTE_FAIL, error, noteId, newNbId, nbId });
    doneCallback(error);
  }
}

// 发布付费文章
function* publishPaidNoteAsync(action) {
  const {
    nbId,
    noteId,
    amount,
    content,
    license,
    audioPaid,
    resolve,
    reject,
  } = action;
  try {
    const { data } = yield call(ajax.updatePNSetting, {
      note_id: noteId,
      amount,
      content,
      license,
      audio_paid: audioPaid,
    });
    yield put({ type: Notes.PUBLISH_PAID_NOTE_SUCCESS, data, noteId, nbId });
    resolve && resolve(data);
  } catch (error) {
    yield put({ type: Notes.PUBLISH_PAID_NOTE_FAIL, error, noteId, nbId });
    reject && reject(error);
  }
}

function* getCoverImgAsync(action) {
  const { noteId, resolve, reject } = action;
  try {
    const { data } = yield call(ajax.getCoverImg, noteId);
    yield put({ type: Notes.GET_COVER_IMG_SUCCESS, data, noteId });
    resolve(data);
  } catch (error) {
    yield put({ type: Notes.GET_COVER_IMG_FAIL, error, noteId });
    reject(error);
  }
}

function* postCoverImgAsync(action) {
  const { noteId, flowType, coverImgUrls, abbr, resolve, reject } = action;
  try {
    const { data } = yield call(ajax.postCoverImg, { noteId, flowType, coverImgUrls, abbr });
    yield put({ type: Notes.POST_COVER_IMG_SUCCESS, data, noteId });
    resolve(data);
  } catch (error) {
    yield put({ type: Notes.POST_COVER_IMG_FAIL, error, noteId });
    reject(error);
  }
}

function* postSetNoteTopAsync(action) {
  const { noteId, resolve, reject } = action;
  try {
    const { data } = yield call(ajax.postSetNoteTop, noteId);
    yield put({ type: Notes.POST_SET_NOTE_TOP_SUCCESS, noteId });
    resolve(data);
  } catch (error) {
    yield put({ type: Notes.POST_SET_NOTE_TOP_FAIL, noteId });
    reject(error);
  }
}

function* postUnsetNoteTopAsync(action) {
  const { noteId, resolve, reject } = action;
  try {
    const { data } = yield call(ajax.postUnsetNoteTop, noteId);
    yield put({ type: Notes.POST_UNSET_NOTE_TOP_SUCCESS, noteId });
    resolve(data);
  } catch (error) {
    yield put({ type: Notes.POST_UNSET_NOTE_TOP_FAIL, noteId });
    reject(error);
  }
}

function* setNoteReprintAbleAsync(action) {
  const { noteId } = action;
  try {
    yield call(ajax.setReprintAble, noteId);
    yield put({ type: Notes.SET_NOTE_REPRINTABLE_SUCCESS, noteId });
    Message.success(i18n.get('tips.set-reprintable-success'));
  } catch (error) {
    yield put({ type: Notes.SET_NOTE_REPRINTABLE_FAIL });
    Message.error(i18n.get('tips.set-reprintable-fail'));
  }
}

function* setNotePublishTimeAsync(action) {
  const { noteId, publishTime, resolve, reject } = action;
  try {
    yield call(ajax.setNotePublishTime, noteId, publishTime);
    yield put({ type: Notes.SET_NOTE_PUBLISH_TIME_SUCCESS, noteId, publishTime });
    resolve();
  } catch (error) {
    reject();
  }
}

export function* watchGetNotes() {
  yield takeEvery(Notes.GET_NOTES, getNotesAsync);
}

export function* watchSortNotes() {
  yield takeLatest(Notes.SORT_NOTES, sortNotesAsync);
}

export function* watchNewNote() {
  yield takeEvery(Notes.NEW_NOTE, newNoteAsync);
}

export function* watchPublishNote() {
  yield takeLatest(Notes.PUBLISH_NOTE, publishNoteAsync);
}

export function* watchUpdateNote() {
  yield takeLatest(Notes.UPDATE_NOTE, updateNoteAsync);
}

export function* watchPrivateNote() {
  yield takeLatest(Notes.PRIVATE_NOTE, privateNoteAsync);
}

export function* watchDeleteNoteSoft() {
  yield takeLatest(Notes.DEL_NOTE_SOFT, deleteNoteSoftAsync);
}

export function* watchMoveNote() {
  yield takeLatest(Notes.MOVE_NOTE, moveNoteAsync);
}

export function* watchPublishPaidNote() {
  yield takeLatest(Notes.PUBLISH_PAID_NOTE, publishPaidNoteAsync);
}

export function* watchGetCoverImg() {
  yield takeLatest(Notes.GET_COVER_IMG, getCoverImgAsync);
}

export function* watchPostCoverImg() {
  yield takeLatest(Notes.POST_COVER_IMG, postCoverImgAsync);
}

export function* watchPostSetNoteTop() {
  yield takeLatest(Notes.POST_SET_NOTE_TOP, postSetNoteTopAsync);
}

export function* watchPostUnsetNoteTop() {
  yield takeLatest(Notes.POST_UNSET_NOTE_TOP, postUnsetNoteTopAsync);
}

export function* watchSetNoteReprintAble() {
  yield takeLatest(Notes.SET_NOTE_REPRINTABLE, setNoteReprintAbleAsync);
}

export function* watchSetNotePublishTime() {
  yield takeLatest(Notes.SET_NOTE_PUBLISH_TIME, setNotePublishTimeAsync);
}



// WEBPACK FOOTER //
// ./src/sagas/NotesSaga.js